import { Card, Typography, CardBody } from '@material-tailwind/react';
import TdLocaisApc from './TdLocaisApc';

const TABLE_HEAD = ['Maquinario', 'quantidade'];

export function TableLocaisApc({ array }) {
  return (
    <Card className="h-full w-full bg-transparent ">
      <CardBody className="overflow-auto  p-0  pb-2">
        <table className="w-full min-w-max table-auto text-left ">
          <thead>
            <tr>
              <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-300 p-2 transition-colors hover:bg-blue-gray-50 dark:bg-darkTh">
                <Typography
                  variant="small"
                  color="black"
                  className="leading-none  uppercase font-extrabold dark:text-white"
                >
                  MAQUINARIO
                </Typography>
              </th>
              <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-300 p-2 transition-colors hover:bg-blue-gray-50 dark:bg-darkTh">
                <Typography
                  variant="small"
                  color="black"
                  className="text-center w-full leading-none  uppercase font-extrabold  dark:text-white "
                >
                  QTD
                </Typography>
              </th>
            </tr>
          </thead>
          <tbody className="bg-lightColoBox dark:bg-darkTdRow">
            {array &&
              array.map((item, index) => <TdLocaisApc item={item} index={index} key={index} />)}
          </tbody>
        </table>
      </CardBody>
    </Card>
  );
}
